document.addEventListener('DOMContentLoaded', () => {
  // ============== Acordeón Global ==============
  const globalHeaders = document.querySelectorAll('.global-accordion-header');
  // Abrir la primera sección por defecto y cerrar el resto
  globalHeaders.forEach((header, index) => {
    const body = header.nextElementSibling;
    if (index === 0) {
      body.style.display = 'block';
    } else {
      body.style.display = 'none';
    }
    
    header.addEventListener('click', () => {
      if (body.style.display === 'block') {
        body.style.display = 'none';
      } else {
        globalHeaders.forEach(h => {
          h.nextElementSibling.style.display = 'none';
        });
        body.style.display = 'block';
      }
    });
  });
  
  // ============== Sub-Acordeón (por color) ==============
  const subHeaders = document.querySelectorAll('.sub-accordion-header');
  subHeaders.forEach(header => {
    header.addEventListener('click', (e) => {
      e.stopPropagation(); // Evitar que se colapse el acordeón global
      const body = header.nextElementSibling;
      if (body.style.display === 'block') {
        body.style.display = 'none';
      } else {
        body.style.display = 'block';
      }
    });
  });
  
  // ============== Botón: Añadir sin personalizar ==============
  const btnAddWithoutPersonalize = document.getElementById('btnAddWithoutPersonalize');
  if (btnAddWithoutPersonalize) {
    btnAddWithoutPersonalize.addEventListener('click', () => {
      let itemsToAdd = [];
      document.querySelectorAll('input[type="number"][name^="quantity_"]').forEach(input => {
        const qty = parseInt(input.value, 10) || 0;
        if (qty > 0) {
          itemsToAdd.push({
            id: parseInt(input.getAttribute('data-variant-id'), 10),
            quantity: qty
          });
        }
      });

      if (itemsToAdd.length === 0) {
        alert('Selecciona al menos un producto con cantidad > 0');
        return;
      }

      // --- INICIO VALIDACIÓN CANTIDAD MÍNIMA ---
      const totalQuantity = itemsToAdd.reduce((sum, item) => sum + item.quantity, 0);
      const minQty = window.minQty || 0;

      if (totalQuantity < minQty) {
        alert(`La cantidad mínima de compra para este producto es de ${minQty} unidades.`);
        return; 
      }
      // --- FIN VALIDACIÓN CANTIDAD MÍNIMA ---

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      })
      .then(res => res.json())
      .then(data => {
        console.log('Añadido sin personalización:', data);
        window.location.href = '/cart';
      })
      .catch(console.error);
    });
  }
  
  // ============== Botón: Ir a Personalizar (Paso intermedio) ==============
  const btnGoToPersonalize = document.getElementById('btnGoToPersonalize');
  if (btnGoToPersonalize) {
    btnGoToPersonalize.addEventListener('click', () => {
      
      let selectedQuantities = [];
      document.querySelectorAll('input[type="number"][name^="quantity_"]').forEach(input => {
        const qty = parseInt(input.value, 10) || 0;
        if (qty > 0) {
          selectedQuantities.push({
            variantId: input.getAttribute('data-variant-id'),
            quantity: qty,
            color: input.getAttribute('data-color'),
            size: input.getAttribute('data-size')
          });
        }
      });

      if (selectedQuantities.length === 0) {
        alert('Selecciona al menos un producto con cantidad > 0');
        return;
      }

      // --- INICIO VALIDACIÓN CANTIDAD MÍNIMA (Antes de dejarle personalizar) ---
      const totalQuantity = selectedQuantities.reduce((sum, item) => sum + item.quantity, 0);
      const minQty = window.minQty || 0;

      if (totalQuantity < minQty) {
        alert(`Para personalizar, necesitas una cantidad mínima de ${minQty} unidades.`);
        return; 
      }
      // --- FIN VALIDACIÓN CANTIDAD MÍNIMA ---

      // --- INICIO VALIDACIÓN LOTES (Antes de personalizar) ---
      const stepQty = window.stepQty || 1;
      if (totalQuantity % stepQty !== 0) {
        alert(`Este producto se vende en packs de ${stepQty} unidades. Por favor ajusta la cantidad a un múltiplo de ${stepQty} (ej: ${stepQty}, ${stepQty*2}...).`);
        return; 
      }
      // --- FIN VALIDACIÓN LOTES ---

      document.getElementById('item-area-marcaje').style.display = 'block';
      window.userQuantities = selectedQuantities;
      console.log('Cantidades seleccionadas:', window.userQuantities);
      
      // Cambiar de sección global: colapsar "Color y cantidad" y expandir "Área marcaje"
      if (globalHeaders.length >= 2) {
        globalHeaders[0].nextElementSibling.style.display = 'none';
        globalHeaders[1].nextElementSibling.style.display = 'block';
      }
      
      // Si la opción "sameMarking" es "no", generar bloques individuales
      const sameMarkingValue = document.querySelector('input[name="sameMarking"]:checked').value;
      if (sameMarkingValue === 'no') {
        
        document.getElementById('markingEachColor').style.display = 'block';
        generateBlocksForEachColor(window.userQuantities);
        
      } else {
        document.getElementById('markingEachColor').style.display = 'none';
      }
    });
  }
  
  // Listener para cambios en el radio "sameMarking"
  document.querySelectorAll('input[name="sameMarking"]').forEach(radio => {
    radio.addEventListener('change', () => {
      const selectedValue = document.querySelector('input[name="sameMarking"]:checked').value;
      if (selectedValue === 'no' && window.userQuantities) {
        document.getElementById('markingEachColor').style.display = 'block';
        document.getElementById('markingAllColors').style.display = 'none';
        generateBlocksForEachColor(window.userQuantities);
      } else {
        document.getElementById('markingEachColor').style.display = 'none';
        document.getElementById('markingAllColors').style.display = 'block';
      }
    });
  });
  
  // Función para generar bloques individuales para cada variante (modo "por color")
  function generateBlocksForEachColor(quantities) {
    const container = document.getElementById('markingEachColorContainer');
    container.innerHTML = ''; // Limpiar contenido anterior
    quantities.forEach(item => {
      const block = document.createElement('div');
      block.className = 'area-color-block';
      block.innerHTML = `
        <h4>${item.color} – ${item.size} (Cantidad: ${item.quantity})</h4>
        <div>
          <label>
            <input type="checkbox" data-area="1">
            AREA 1 - frontal
          </label>
          <div class="area-options">
            <label>Método de impresión:</label>
            <select class="selectTrabajo">
              <option value="SUB01">SUB01</option>
              <option value="SERIGRAFIA">Serigrafía</option>
              <option value="TRANSFER">Transfer</option>
            </select>
            <br>
            <label>Nº de colores:</label>
            <select class="selectColores">
              <option value="1">1 COLOR</option>
              <option value="2">2 COLORES</option>
              <option value="FULLCOLOR">FULLCOLOR</option>
            </select>
            <br>
            <label>
              <input type="checkbox" class="checkRepeticionCliche">
              Repetición Cliché
            </label>
          </div>
        </div>
      `;
      container.appendChild(block);
      
      // Listener para mostrar/ocultar opciones en cada bloque
      const areaCheckbox = block.querySelector('input[data-area="1"]');
      const areaOptions = block.querySelector('.area-options');
      areaCheckbox.addEventListener('change', () => {
        areaOptions.style.display = areaCheckbox.checked ? 'block' : 'none';
      });
    });
  }
  
  // ============== Botón: Añadir al carrito con personalización (FINAL) ==============
  const btnAddToCartWithPersonalization = document.getElementById('btnAddToCartWithPersonalization');
  if (btnAddToCartWithPersonalization) {
    btnAddToCartWithPersonalization.addEventListener('click', () => {
      
      if (window.userQuantities && window.userQuantities.length > 0) {
          const totalQuantity = window.userQuantities.reduce((sum, item) => sum + item.quantity, 0);
          const minQty = window.minQty || 0;
          const stepQty = window.stepQty || 1; // <--- AÑADIDO: Ahora el botón final sabe qué es stepQty

          if (totalQuantity < minQty) {
            alert(`La cantidad mínima de compra es de ${minQty} unidades.`);
            return;
          }

          if (totalQuantity % stepQty !== 0) {
             alert(`La cantidad debe ser múltiplo de ${stepQty}. Tienes seleccionadas ${totalQuantity} unidades.`);
             return;
          }
      }
      // --- FIN VALIDACIÓN CANTIDAD MÍNIMA ---

      const sameMarkingValue = document.querySelector('input[name="sameMarking"]:checked').value;
      let personalizationData = {};
      
      if (sameMarkingValue === 'yes') {
        personalizationData['all'] = {
          area1: {
            activo: document.getElementById('areaActivaAll1').checked,
            metodo: document.getElementById('selectTrabajoAll1')?.value || null,
            numColores: document.getElementById('coloresAll1')?.value || null,
            repeticion: document.getElementById('repeticionClicheAll1')?.checked || false
          }
        };
      } else {
        personalizationData['por_color'] = {};
        document.querySelectorAll('#markingEachColorContainer .area-color-block').forEach(block => {
          const title = block.querySelector('h4').textContent;
          // Suponemos formato "Color – Talla (Cantidad: X)"
          const parts = title.split(' – ');
          const colorName = parts[0];
          const sizePart = parts[1].split(' (')[0];
          const key = colorName + ' ' + sizePart;
          personalizationData['por_color'][key] = {};
          
          const areaCheckbox = block.querySelector('input[data-area="1"]');
          if (areaCheckbox && areaCheckbox.checked) {
            const metodo = block.querySelector('.selectTrabajo').value;
            const numCols = block.querySelector('.selectColores').value;
            const repet = block.querySelector('.checkRepeticionCliche').checked;
            personalizationData['por_color'][key]['area1'] = {
              activo: true,
              metodo: metodo,
              numColores: numCols,
              repeticion: repet
            };
          }
        });
      }
      
      let itemsToAdd = [];
      if (!window.userQuantities || window.userQuantities.length === 0) {
        alert('No se han seleccionado cantidades');
        return;
      }
      window.userQuantities.forEach(item => {
        itemsToAdd.push({
          id: parseInt(item.variantId, 10),
          quantity: item.quantity,
          properties: {
            'Personalización': JSON.stringify(personalizationData)
          }
        });
      });
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      })
      .then(res => res.json())
      .then(data => {
        console.log('Añadido con personalización:', data);
        window.location.href = '/cart';
      })
      .catch(console.error);
    });
  }
});
